import { FilterFilled, FilterOutlined } from "@ant-design/icons";
import React from "react";

export const FilterIcon = React.memo(function FilterIcon({
    isFiltered,
}: { isFiltered: boolean }) {
    return (
        <span style={{ marginLeft: 4, cursor: 'pointer' }} title="Lọc">
            {isFiltered ? <FilterFilled /> : <FilterOutlined />}
        </span>
    );
});